import { render } from "./QrcodeRewardDiscount.vue?vue&type=template&id=36bdcef2&scoped=true"
import script from "./QrcodeRewardDiscount.vue?vue&type=script&lang=js"
export * from "./QrcodeRewardDiscount.vue?vue&type=script&lang=js"

import "./QrcodeRewardDiscount.vue?vue&type=style&index=0&id=36bdcef2&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bdcef2"]])

export default __exports__